<template>
  <div class="page-act8-main">    
    <div class="main" style="background-image:url(static/img/act/8/main/river.png)">
       <!-- 云 begin -->
        <img class="act-8-main-cloud-2 act-8-animation-cloud-2" src="static/img/act/8/banner/cloud-1.png">  
        <img class="act-8-main-cloud-3 act-8-animation-cloud-3" src="static/img/act/8/banner/cloud-1.png">          
        <img class="act-8-main-cloud-1 act-8-animation-cloud-1" src="static/img/act/8/banner/cloud-1.png">          
      <!-- 云 over --> 

      <!-- 游泳，桂人 begin -->
    <!--  <span class="act-8-main-guiren-wrap act-8-animation-guiren-swim-y">
        <span class="act-8-animation-guiren-swim-x">
          <img class="act-8-main-guiren act-8-animation-bounce" src="static/img/act/8/banner/guiren.png">  
        </span>
      </span> --> 
      <!-- 游泳，桂人 over --> 
      
       <!-- 游泳，柳人 begin -->
     <!--    <span class="act-8-main-liuren-wrap act-8-animation-swim-liuren-y">
        <span class="act-8-animation-swim-liuren-x">
          <img class="act-8-main-liuren act-8-animation-bounce" src="static/img/act/8/banner/liuren.png">  
        </span>
      </span> --> 
      <!-- 游泳，柳人 over -->
          
          
      <div class="tower-wrap" v-bind:style="{'margin-top':marginTop}">
        <img class="tower" src="static/img/act/8/main/towerV2.png">
        <!-- 游泳，桂人 begin -->
        <span class="act-8-banner-guiren-wrap act-8-animation-guiren-swim-y" v-bind:style="{'top':guirenTop}" v-if="animationShow"> 
          <span class="act-8-animation-guiren-swim-x">             
            <!--<img class="act-8-main-guiren-title act-8-animation-bounce act-8-animation-guiren-swim-guiren-title-x" src="static/img/act/8/guiren-title.png"/>  --> 
            <img class="act-8-main-guiren-title act-8-animation-guiren-swim-guiren-title-x" src="static/img/act/8/guiren-title.png"/>             
            <img class="act-8-banner-guiren act-8-animation-bounce" src="static/img/act/8/banner/guiren.png">  
          </span>
        </span> 
        <!-- 游泳，桂人 over --> 
      
        <!-- 游泳，柳人 begin -->
        <span class="act-8-main-liuren-wrap act-8-animation-swim-liuren-y"  v-bind:style="{'top':liurenTop}"  v-if="animationShow"> 
          <span class="act-8-animation-swim-liuren-x"> 
            <img class="act-8-banner-liuren-title act-8-animation-bounce act-8-animation-swim-liuren-title-x" src="static/img/act/8/liuren-title.png"/>                           
            <img class="act-8-banner-liuren act-8-animation-bounce" src="static/img/act/8/banner/liuren.png">  
          </span>
        </span>
        <!-- 游泳，柳人 over -->

        <!-- 福利全开 -->
        <div @click="displayYyj" class="btn-main-flqk act-8-main-btn-layer"  ></div>  
        <!-- 精品线路 -->
        <div @click="displayJpxl" class="btn-main-jpxl act-8-main-btn-layer" ></div>  
        <!-- 月月游柳 -->
        <div @click="displayYyyl" class="btn-main-yyyl act-8-main-btn-layer" ></div> 
        <!-- 柳人力荐 -->
        <div @click="displayGallery(3)" class="btn-main-lrlj act-8-main-btn-layer" ></div>  
        <!-- 城市漫步 -->
        <div  @click="displayCsmbGallery()" class="btn-main-csmb act-8-main-btn-layer"  ></div>  

      </div>
 
      <!-- 城市漫步 -->
       <transition name="fade">
        <div v-show="isCsmbGalleryShow" class="act-8-main-gallery act-8-csmb-gallery ">
          <img src="static/img/act/8/main/csmb/bg.png" class="act-8-main-widnow-mtj-bg" v-if="this.act3Swiper3.activeIndex != 3">     
          <img src="static/img/act/8/main/csmb/bg-3.png" class="act-8-main-widnow-mtj-bg" v-if="this.act3Swiper3.activeIndex == 3">   
          <img @click="closeCsmbGallery" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" >  
          <!-- 轮播图 3 -->
          <div class="act-8-main-gallery-swiper-wrap">
            <div class="swiper-container act-8-swiper-csmb"> 
              <div class="swiper-wrapper"> 
                <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                  <img class="swiper-lazy" src="static/img/act/8/main/csmb/1.png?v=2" >                  
                </div>  
                <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                  <img class="swiper-lazy" src="static/img/act/8/main/csmb/2.png" >                  
                </div>  
                <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                  <img class="swiper-lazy" src="static/img/act/8/main/csmb/3.png" >                  
                </div>  
              </div>
            </div> 
          </div>
        
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner3Next()"></div>
            <div class="swiper-button-prev" @click="acT3Banner3Prev()"></div> 
        <!--   轮播图 3 end-->

        </div>
      </transition>
      <!-- 城市漫步 over -->
     
      <!-- 美图卷 -->
       <transition name="fade">
        <div v-show="isWindow1Show" class="act-8-main-widnow-mtj">
          <img src="static/img/act/8/main/window-flqk.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeWindow1" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" > 
          <div class="act-8-main-widnow1-p1" @click="displayGallery(1)" ></div>
          <div class="act-8-main-widnow1-p2" @click="displayGallery(2)"  ></div>
          <div class="act-8-main-widnow1-p3" @click="displayGallery(3)"  ></div>
        </div>
      </transition>
      <!-- 美图卷 end-->

      <!-- 图集 -->
       <transition name="fade">
        <div v-show="isGalleryShow" class="act-8-main-gallery">
          <img src="static/img/act/8/main/lrtj/bg.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeGallery" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" >            

        
        <!-- 轮播图 3 -->
        <div class="act-8-main-gallery-swiper-wrap">
          <div class="swiper-container act-3-swiper-3">


            <div class="swiper-wrapper">
             <!--
              <div v-for="(item, index) in galleryData" class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" :data-src="item.img" @click="goNews(item.id)">
                <div class="swiper-lazy-preloader"></div>
              </div>
             -->

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/guilinv2.png" @click="goNews(1)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/nanninv2.png"  @click="goNews(2)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/3.png"  @click="goNews(3)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/4.png"  @click="goNews(4)">
                <div class="swiper-lazy-preloader"></div>
              </div>

 
              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/5.png"  @click="goNews(5)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/6.png"  @click="goNews(6)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/7.png"  @click="goNews(7)">
                <div class="swiper-lazy-preloader"></div>
              </div>

              <div class="swiper-slide" v-bind:style="{height:swiperSlideHeight}" >
                <img class="swiper-lazy" src="static/img/act/8/main/lrtj/next.png" >
                <div class="swiper-lazy-preloader"></div>
              </div>



            </div>

          </div> 
        </div>
        
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner3Next()"></div>
            <div class="swiper-button-prev" @click="acT3Banner3Prev()"></div> 
        <!--   轮播图 3 end-->

        </div>
      </transition>
      <!-- 图集 end-->
        
      <!-- 视频卷 -->
       <transition name="fade">
        <div v-show="isVideoShow" class="act-8-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-video.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeVideo" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" > 
          <video v-if="isVideoShow" src="static/img/act/7/video/20190628.mp4" poster="static/img/act/7/video/20190628-poster.jpg" class="video" x5-playsinline="" playsinline="" webkit-playsinline="" x5-video-player-fullscreen="true" controls></video>
        </div>
      </transition>
      <!-- 视频卷 end-->

      
      <!-- 身世卷 -->
       <transition name="fade">
        <div v-show="isSsjShow" class="act-8-main-widnow-mtj">
          <img src="static/img/act/7/banner/window-ssj.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeSsj" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" >    
          <div class="flqk-contents">
            <p>巍巍大武山、汩汩西沘河、沧桑古榕树、神奇报时泉，山灵水秀的自然环境孕育出万亩荷海，十里飘香——柳江区百朋镇怀洪村下伦屯，素有“中国玉藕之乡”的美誉，所产的莲藕嫩白如玉、清甜脆口，闻名遐迩。</p>
            <p>自2012年起，百朋每年都举办一次荷花文化旅游节，打造以“百朋玉藕”为品牌的节庆文化。眼下，以下伦屯为中心的万亩藕海荷叶飘香，朵朵荷花含苞待放，迎来了游览观赏的大好时节。</p>
            <img src="static/img/act/7/ssj/1.jpg" >
            <p>今年荷花文化旅游节首次迎来了吉祥物“荷荷”“美美”，取自“和”、“美”之意，让人向往。</p>
            <img src="static/img/act/7/ssj/2.jpg" >
          </div>       
        </div>
      </transition>
      <!-- 身世卷 end-->
      
      <!-- 福利全开 -->
       <transition name="fade">
        <div v-show="isFlqkShow" class="act-8-main-widnow-mtj">
          <img src="static/img/act/8/main/window-flqk.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeYyj" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" >   
          <div class="act-8-main-flqk-p1" @click="displayFlqkItem(1)" ></div>
          <div class="act-8-main-flqk-p2" @click="displayFlqkItem(2)"  ></div>
          <div class="act-8-main-flqk-p3" @click="displayFlqkItem(3)"  ></div>   
          <div class="act-8-main-flqk-p4" @click="displayFlqkItem(4)"  ></div>   
        </div>
      </transition>
      <!-- 福利全开 over-->
 
      <!-- 福利全开 内容 -->
       <transition name="fade">
        <div v-show="isFlqkItemShow" class="act-8-main-widnow-mtj">
          <img v-if="flqkItemId == 1" src="static/img/act/8/main/flqk/bg-1.png" class="act-8-main-widnow-mtj-bg">   
          <img v-if="flqkItemId == 2" src="static/img/act/8/main/flqk/bg-2.png" class="act-8-main-widnow-mtj-bg">   
          <img v-if="flqkItemId == 3" src="static/img/act/8/main/flqk/bg-3.png" class="act-8-main-widnow-mtj-bg">   
          <img v-if="flqkItemId == 4" src="static/img/act/8/main/flqk/bg-4.png" class="act-8-main-widnow-mtj-bg">   

          <img @click="closeYyjItem" src="static/img/act/7/btn-return.png" class="act-8-main-widnow1-btn-close" >  

          <div v-if="flqkItemId == 1" class="flqk-contents">
            <div class="flqk-contents-item-title">柳州市建设旅游名城奖励办法</div>         
            <img src="static/img/act/8/main/flqk/1.jpg" >
            <p>鼓励市内外旅行社引客入柳。</p>   
            <p>（一）鼓励旅行社组织游客包机、专列、大巴团来柳旅游。</p>   
            <p>上一年度在柳州市区内住宿一晚以上（含一晚）且游览一个以上收费景点、达到一定规模的来柳包机、专列、大巴旅游团队，按以下标准奖励旅行社</p>   
            <p>1.单次组织包机入柳旅游100人以上（含100人），按每人100元标准奖励。</p>   
            <p>2.单次组织旅游火车专列入柳旅游300人以上（含300人），按每人50元标准奖励。</p>   
            <p>3.单次组织旅游大巴团入柳旅游300人以上（含300人），按每人50元奖励组团社。</p>   
            <p>（二）鼓励本市旅行社接待过夜海外旅游者。</p>   
            <p>上一年度在柳州市区内住宿一晚以上（含一晚）且游览一个以上收费景点的，按以下标准奖励旅行社：</p>   
            <p>接待过夜海外旅游者500人次至1000人次以下（不含1000人次）按每人次20元标准奖励；接待过夜海外旅游者1000人次至3000人次以下（不含3000人次），按每人次30元标准奖励；接待过夜海外旅游者3000人次以上（含3000人次），按每人次40元标准奖励。</p>             
            <p>（三）鼓励市外组团社组织入柳过夜海外旅游者。</p>             
            <p>上一年度市外组团社组织入柳过夜海外旅游者在柳州市区内住宿一晚以上（含一晚）并游览一个以上收费景点，且所组入柳过夜海外旅游者达1000人次以上（含1000人次），按每人次30元标准给予市场宣传推介奖励，同一团队不重复奖励。</p>                         
          </div>   

          <div v-if="flqkItemId == 2" class="flqk-contents">
            <div class="flqk-contents-item-title">柳州市稳消费促增长工作方案</div>     
            <img src="static/img/act/8/main/flqk/2.jpg" >
            <p>“引客入柳”发展旅游消费。鼓励柳州旅行社接待境外旅游团队，接待入柳10人以上境外旅游团队（含港澳台地区游客），在柳州限额以上或市区三星级（含）以上星级饭店住宿一晚并游览市区两个A级景区（其中至少一个收费景区），按80元/人给予旅行社资金奖励。</p>       
            <p>外市旅行社可通过柳州旅行社进行申报。</p>  
          </div>   

          <div v-if="flqkItemId == 3" class="flqk-contents">
            <div class="flqk-contents-item-title">航空“引客入柳”优惠政策</div>
            <img src="static/img/act/8/main/flqk/3.jpg" >
            <p>近年来，市委、市政府高度重视我市民航业发展，柳州机场实现了跨越式发展。2019年上半年，柳州机场总起降累计6673架次,同比增加624架次,增幅10.32%，旅客吞吐量年累计74万余人,同比增加9万余人,增幅13.95%。今年夏秋航季换季后，柳州机场在飞航线由14条增加至17条，通达城市从16个增加至21个。为促进各旅行社“引客入柳”积极性，提高柳州航线客座率，柳州市文旅集团和柳州机场继续施行航线促销和惠民政策。下面我为大家分别介绍。</p>         
            <p>柳州市文旅集团龙翔航线经营管理有限公司柳州市航班“引客入柳”奖励政策</p>         
            <p>一、奖励对象</p>         
            <p>“引客入柳”的各签约旅行社。旅行社以团队方式组织广西区外旅客乘坐经柳州机场往返航班或者进港、出港单程航班抵（离）广西。</p>         
            <p>适用范围：10人（含）以上(参照目前柳州在飞航空公司对成团的最低人数要求)乘坐柳州机场国内外航班的旅客团队（婴儿旅客除外）。</p>         
            <p>二、奖励标准</p>         
            <p>奖励旅行社以团队方式组织广西区外旅客经柳州机场进港、出港抵（离）广西。经柳州机场进港或出港航班奖励60元/人，往返进出柳州机场航班奖励80元/人。</p>         
            <p>三、奖励期限</p>    
            <p>2019年7月1至2019年9月30日止。奖励期限内因特殊情况需暂停奖励政策，柳州市龙翔航线经营管理有限公司应提前45天以公函形式通知相关旅行社。</p>               
          </div>   
 
          <div v-if="flqkItemId == 4" class="flqk-contents">
            <div class="flqk-contents-item-title">柳州机场2019年下半年惠民措施</div>
            <img src="static/img/act/8/main/flqk/4.jpg" >
            <p>措施一：外地车辆免费停车服务。南宁市、桂林市、贺州市、来宾市、河池市、贵港市、玉林市、三江县、融安县、融水县、柳城县、鹿寨县等地号牌的乘机旅客的车辆，最多可在柳州机场停车场免费停放7天。适用范围：所有乘机旅客；适用时间：至2019年12月31日。</p>   
            <p>措施二: 柳州机场安排车辆负责柳州市周边市县团队从柳州汽车南站至机场往返免费接送。适用范围：10人（含）以上旅游团队；适用时间：至2019年12月31日。</p>  
            <p>其它团队促销措施：在需要培育、支持的航线上，给予旅行社组织柳州周边团队从柳州机场乘机出行“组团”服务费、给予旅行社组织省外团队乘坐柳州机场航班到广西旅游“引客入柳”服务费，为乘坐柳州机场早晚班的周边旅游团队免费安排住宿，具体实施细则请联系柳州机场并签订合作协议。</p>  
            <p>希望桂林市旅行社加强与柳州市旅行社的合作，充分利用我市出台的奖励政策多组织游客来柳州旅游、消费，促进两地之间的文化旅游交流。</p>  
          </div>    
 
        </div>
      </transition>
      <!-- 福利全开 内容 over-->
       

      <!-- 精品线路 -->
       <transition name="fade">
        <div v-show="isJpxlShow" class="act-8-main-widnow-mtj">
          <img src="static/img/act/8/main/jpxl/bg.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeJpxl" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" >   
          <div class="act-8-main-jpxl-p1" @click="displayJpxlItem(1)" ></div>
          <div class="act-8-main-jpxl-p2" @click="displayJpxlItem(2)"  ></div>
          <div class="act-8-main-jpxl-p3" @click="displayJpxlItem(3)"  ></div>    
        </div>
      </transition>
      <!-- 精品线路 over-->
 
      <!-- 精品线路 内容 -->
       <transition name="fade">
        <div v-show="isJpxlItemShow" class="act-8-main-widnow-mtj">
          <img v-if="jpxlItemId == 1" src="static/img/act/8/main/jpxl/1-bg.png" class="act-8-main-widnow-mtj-bg">   
          <img v-if="jpxlItemId == 2" src="static/img/act/8/main/jpxl/2-bg.png" class="act-8-main-widnow-mtj-bg">   
          <img v-if="jpxlItemId == 3" src="static/img/act/8/main/jpxl/3-bg.png" class="act-8-main-widnow-mtj-bg">   
          <img @click="closeJpxlItem" src="static/img/act/7/btn-return.png" class="act-8-main-widnow1-btn-close" >  

          <div v-if="jpxlItemId == 1" class="jpxl-contents">
            <div class="flqk-contents-item-title">柳州一日游精品线路</div>      
            <p>依托现代都市建设风貌、历史文脉、地方文化个性、山水资源、民族民俗风情、工业制造产业、休闲农业及乡村旅游资源，打造一批主题鲜明、各具特色的柳州一日游精品线路。</p>      
            <img src="static/img/act/8/main/jpxl/1/1.jpg" >
            <p class="flqk-item-title">1.山水风光主题</p>   
            <p>柳州山水得天独厚，大龙潭景区喀斯特自然山水景观秀丽，百里柳江穿城而过，抱成城壶，有“天然大盆景”的美誉，登马鞍山顶可观“四野环山立，一水抱城流”的“壶城”景象。</p>   
            <p>我们为大家推荐的线路是：大龙潭景区—马鞍山观柳州全景-柳州奇石馆-环江滨水大道--百里柳江（夜游柳江）</p>        
            <img src="static/img/act/8/main/jpxl/1/2.jpg" >
            <p class="flqk-item-title">2.历史人文主题</p>   
            <p>柳州历史悠久，文化厚重。白莲洞文化及“柳江人”遗址在人类学上占有相当重要地位。为纪念柳宗元建造的柳侯祠承载着柳州精神的根源-柳宗元文化。</p>   
            <p>我们为大家推荐的线路是：白莲洞考古遗址公园-柳侯公园（柳侯祠）-柳州市博物馆-工业博物馆-窑埠古镇-百里柳江（夜游柳江）</p>     
            <img src="static/img/act/8/main/jpxl/1/3.jpg" >
            <p class="flqk-item-title">3.都市休闲主题</p>   
            <p>柳州城就是一道美丽的风景，赏全国最大的奇石主题公园---马鹿山奇石博览园、尝国际“网红”小吃——柳州螺蛳粉、游卡乐星球欢乐世界和克里湾水乐园，是柳州城市休闲旅游的主要产品。每年4月，柳州紫荆花盛开，通过紫荆花赏花线路可以充分感受柳州“紫荆花城”的魅力。我们为大家推荐的线路是：</p>   
            <p>（1）柳州奇石馆-洛维螺蛳粉产业园-云顶观光（地王国际财富中心）-环江滨水大道-窑埠古镇-百里柳江（夜游柳江）</p>   
            <p>（2）卡乐星球主题乐园-克里湾·水乐园-环江滨水大道-百里柳江（夜游柳江）</p>   
            <p>（3）紫荆花赏花线路：（3）紫荆花赏花线路：柳侯公园（弯塘路、文惠路）-市民广场（东堤路）-蟠龙山公园（蟠龙路）-窑埠古镇-百里柳江（夜游柳江）</p>   
            <img src="static/img/act/8/main/jpxl/1/4.jpg" >  
            <p class="flqk-item-title">4.工业旅游主题</p>           
            <p>柳州工业旅游基础深厚，上汽通用五菱宝骏基地是展示“柳州制造”的重要窗口，2018年获评国家4A级景区，柳州工业博物馆荣获“国家工业遗产旅游基地”称号。</p>             
            <p>我们为大家推荐的线路是：上汽通用五菱宝骏基地-洛维螺蛳粉产业园-工业博物馆-百里柳江（夜游柳江）</p>  
            <img src="static/img/act/8/main/jpxl/1/5.jpg" >    
            <p class="flqk-item-title">5.综合精品旅游线路</p>     
            <p>根据旅游资源特点和游客需求，建议重点打造推出综合精品线路。</p>             
            <p>大龙潭景区-马鞍山观柳州全景-柳州奇石馆-工业博物馆-窑埠古镇-百里柳江（夜游柳江）</p>      
            <img src="static/img/act/8/main/jpxl/1/6.jpg" >                     
          </div>   

          <div v-if="jpxlItemId == 2" class="jpxl-contents">
            <div class="flqk-contents-item-title">柳州二日游精品线路</div>    
            <p>根据游客对旅游产品的不同需求，采取半定制的形式，以“柳州市一日游综合精品线路+”的方式整合柳州二日游精品线路。</p>   
            <img src="static/img/act/8/main/jpxl/2/1.jpg" >     
            <p>1. 柳州市一日游综合精品线路（大龙潭景区-马鞍山观柳州全景-柳州奇石馆-工业博物馆-窑埠古镇-夜游柳江）-融水县老君洞景区-融水县双龙沟景区-融水梦呜苗寨（《苗魅》演出）</p>    
            <img src="static/img/act/8/main/jpxl/2/2.jpg" >     
            <p>2. 柳州市一日游综合精品线路（大龙潭景区-马鞍山观柳州全景-柳州奇石馆-工业博物馆-窑埠古镇-夜游柳江）-三江县程阳八寨景区-三江县大侗寨景区（《坐妹》演出）-三江县布央仙人山景区</p> 
            <img src="static/img/act/8/main/jpxl/2/3.jpg" >         
            <p>3. 柳州市一日游综合精品线路（大龙潭景区-马鞍山观柳州全景-柳州奇石馆-工业博物馆-窑埠古镇-夜游柳江）-鹿寨县中渡古镇-鹿寨县祥荷乡韵景区-鹿寨香桥岩风景区</p>    
            <img src="static/img/act/8/main/jpxl/2/4.jpg" >
          </div>   

          <div v-if="jpxlItemId == 3" class="jpxl-contents">
            <div class="flqk-contents-item-title">柳州三日游精品线路</div>
            <p>柳州市一日游综合精品线路（大龙潭景区-马鞍山观柳州全景-柳州奇石馆-工业博物馆-窑埠古镇-夜游柳江）-融水县老君洞景区-融水县双龙沟景区-融水梦呜苗寨（《苗魅》演出）-三江县程阳八寨景区-三江县大侗寨景区（《坐妹》演出）-三江县布央仙人山景区</p>   
            <img src="static/img/act/8/main/jpxl/3/1.jpg" >   
            <img src="static/img/act/8/main/jpxl/3/2.jpg" >
          </div>    
 
        </div>
      </transition>
      <!-- 精品线路 内容 over-->
       

      <!-- 月月游柳 -->
       <transition name="fade">
        <div v-show="isYyylShow" class="act-8-main-widnow-mtj">
          <img src="static/img/act/8/main/yyyl/11months.png" class="act-8-main-widnow-mtj-bg">             
          <div class="july" @click="goNews(1001)"></div>           
          <div class="july" style="left:32%;" @click="goNews(1002)"></div>
          <div class="july" style="left:66%;top: 15%;height: 36%;" @click="goNews(1003)"></div>
          <div class="july" style="left:0%;top: 50%;height: 36%;" @click="goNews(1004)"></div>
          <img @click="closeYyyl" src="static/img/act/8/btn-close.png" class="act-8-main-widnow1-btn-close" style="opacity:0">   
        </div>
      </transition>
      <!-- 月月游柳 over-->

      <img class="mount" src="static/img/act/8/banner/mount.png">

    </div>    
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 
import { ImagePreview } from "vant";
//动画
import Velocity from "velocity-animate";
//轮播
import Swiper from 'swiper' 
import 'swiper/dist/css/swiper.min.css'

export default {
  name: "Act6Banner",
  components: {
    'nav-tabbar': NavTabbar,   
    "van-image-preview": ImagePreview
  },
  data() {
    return {
      /** 城市漫步 */
      isCsmbGalleryShow:false,
      /** 城市漫步 */

      marginTop:"0",
      liurenTop:'106%',
      guirenTop:'58%',
      isShow:false,
      animationShow:false,
      isWindow1Show:false,
      isGalleryShow:false,
      act3Swiper3:'',      
      gallery1Data:[
        {img:'static/img/act/7/htmj/1.jpg'},
        {img:'static/img/act/7/htmj/2.jpg'},
        {img:'static/img/act/7/htmj/3.jpg'},
        {img:'static/img/act/7/htmj/4.jpg'},
        {img:'static/img/act/7/htmj/5.jpg'},
        {img:'static/img/act/7/htmj/6.jpg'},
        {img:'static/img/act/7/htmj/7.jpg'},
        {img:'static/img/act/7/htmj/8.jpg'},
        {img:'static/img/act/7/htmj/9.jpg'},
        {img:'static/img/act/7/htmj/10.jpg'},
        {img:'static/img/act/7/htmj/11.jpg'},
        {img:'static/img/act/7/htmj/12.jpg'},
        {img:'static/img/act/7/htmj/13.jpg'},
      ],
      gallery2Data:[        
        {img:'static/img/act/7/jcby/1.jpg'},
        {img:'static/img/act/7/jcby/2.jpg'},
        {img:'static/img/act/7/jcby/3.jpg'},
        {img:'static/img/act/7/jcby/4.jpg'},
        {img:'static/img/act/7/jcby/5.jpg'},
        {img:'static/img/act/7/jcby/6.jpg'},
        {img:'static/img/act/7/jcby/7.jpg'},
        {img:'static/img/act/7/jcby/8.jpg'},
        {img:'static/img/act/7/jcby/9.jpg'},
        {img:'static/img/act/7/jcby/10.jpg'},
        {img:'static/img/act/7/jcby/11.jpg'},
        {img:'static/img/act/7/jcby/12.jpg'},
        {img:'static/img/act/7/jcby/13.jpg'},

      ],
      gallery3Data:[        
        {id:1,img:'static/img/act/8/main/lrtj/guilin.png'},
        {id:2,img:'static/img/act/8/main/lrtj/next.png'},
        {id:3,img:'static/img/act/8/main/lrtj/nannin.png'},

      ],
      galleryData:[],
      galleryIndex:1,
      galleryTotal:0,
      galleryTitle:'荷塘美景',
      swiperSlideHeight:'auto',
      /* 视频卷 */
      isVideoShow:false,
      /* 视频卷 end */
      /* 身世卷 */
      isSsjShow:false,
      /* 身世卷 end */
      
      /* 福利全开 */
      isFlqkShow:false,
      isFlqkItemShow:false,
      yyjItemId:0,
      flqkItemId:0,
      /* 友谊卷 end */

      /* 精品线路 */
      isJpxlShow:false,
      isJpxlItemShow:false,
      jpxlItemId:0,
      /* 精品线路 end */

      /* 月月游柳 */
      isYyylShow:false,
      isYyylItemShow:false,
      yyylItemId:0,
      /* 月月游柳 end */


      act7FirstMusicPlay:true,
    };
  },
  destroyed(){ 
    console.log('destroyed') 
  },
  mounted() { 
    //alert(3)
    console.log('mounted') 
  },
  created() {    
    if(document.documentElement.clientHeight<=603){
      this.marginTop = '-28%'
      this.liurenTop = '100%' 
    }
    if(document.documentElement.clientHeight<=554){
      this.marginTop = '-32%'
      this.liurenTop = '100%'
    }
    console.log('created')
    let vm = this
    //移除loading
    if(this.removeLoader()){
      setTimeout(function(){
        vm.isShow = true 
        vm.animationShow = true
      },2000)   
    } else{
      vm.isShow = true
      vm.animationShow = true
    }
    /*
    this.setDocumentV2(
      "桂人游柳 柳人游柳",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/8/share.jpg?v=2"
    );
    */
    _czc.push(['_trackEvent', '桂人游柳 柳人游柳', '点击', '活动主页面','1','8']);  
    
    
  },
  methods: { 
    displayFlqkItem(id){
      this.flqkItemId = id
      this.galleryData = [];
      this.isFlqkItemShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '“风情柳州 桂人游柳”旅游推介会';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          vm.initSwiper();
        }, 200);
      }, 300);
      
    },
    /** 精品线路 */
    displayJpxl(){
      this.isJpxlShow = true
    },
    closeJpxl(){
      this.isJpxlShow = false
    },
    closeJpxlItem(){
      this.isJpxlItemShow = false 
    },
    displayJpxlItem(id){
      this.jpxlItemId = id
      this.galleryData = [];
      this.isJpxlItemShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '藕遇美食';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          vm.initSwiper();
        }, 200);
      }, 300);
      
    },
    /** 精品线路  over */



 /** 月月游柳 */
    displayYyyl(){
      this.isYyylShow = true
    },
    closeYyyl(){
      this.isYyylShow = false
    },
    closeYyylItem(){
      this.isYyylItemShow = false 
    },
    displayYyylItem(id){
      this.jpxlItemId = id
      this.galleryData = [];
      this.isYyylItemShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '“风情柳州 桂人游柳”旅游推介会';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          vm.initSwiper();
        }, 200);
      }, 300);
      
    },
    /** 月月游柳  over */














    initLrljSwiper(){
      this.act3Swiper3 = [];
      let vm  = this      
      this.act3Swiper3 = new Swiper('.act-3-swiper-3', {
        initialSlide:6,
        autoplay:false,
        loop:false, 
        slidesPerView: 3,
	      centeredSlides: true,
        lazy: {
          loadPrevNext: true,
        },
        on:{
           click: function(){
             if(this.activeIndex<2){
              vm.goNews(this.activeIndex+1);
             }
          },
          slideChangeTransitionStart: function(){ 
            if(vm.act3Swiper3.realIndex || vm.act3Swiper3.realIndex == 0){
              vm.galleryIndex = vm.act3Swiper3.realIndex+1
            }
          },
        }
      })
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;  
      this.swiperSlideHeight =( w * (352.5/375) * (440.63/352.5)  * (206.53 / 440.63) ) + 'px';
    },

    initSwiper(){
      this.act3Swiper3 = [];
      let vm  = this      
      this.act3Swiper3 = new Swiper('.act-3-swiper-3', {
        initialSlide:1,
        autoplay:false,
        loop:false, 
        slidesPerView: 3,
	      centeredSlides: true,
        lazy: {
          loadPrevNext: true,
        },
        on:{
           click: function(){
             if(this.activeIndex<2){
              vm.goNews(this.activeIndex+1);
             }
          },
          slideChangeTransitionStart: function(){ 
            if(vm.act3Swiper3.realIndex || vm.act3Swiper3.realIndex == 0){
              vm.galleryIndex = vm.act3Swiper3.realIndex+1
            }
          },
        }
      })
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;  
      this.swiperSlideHeight =( w * (352.5/375) * (440.63/352.5)  * (206.53 / 440.63) ) + 'px';
    },
    displayWindow1(){
      this.isWindow1Show = true
    },
    closeWindow1(){
      this.isWindow1Show = false
    },
    /** 城市漫步 */
    
    displayCsmbGallery(id){
      this.galleryData = [];
      this.isCsmbGalleryShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '“风情柳州 桂人游柳”旅游推介会';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          vm.initCsmbSwiper();
        }, 200);
      }, 300);
      
    },    
    closeCsmbGallery(){
      this.isCsmbGalleryShow = false
    },
    initCsmbSwiper(){
      this.act3Swiper3 = [];
      let vm  = this      
      this.act3Swiper3 = new Swiper('.act-8-swiper-csmb', {
        initialSlide:0,
        autoplay:true,
        loop:true, 
        slidesPerView: 1,
	      centeredSlides: true,
        lazy: {
          loadPrevNext: true,
        },
        on:{
           click: function(){            
             if(this.activeIndex<2){
              window.location.href = "https://shop41568534.youzan.com/v2/showcase/goods?alias=2xk7si0jc6b9q&scan=1&activity=none&from=kdt&qr=directgoods_496342570&redirect_count=1&oid=57280069";
             }else{
              vm.goNews(20191014);
             }
          },
          slideChangeTransitionStart: function(){ 
            if(vm.act3Swiper3.realIndex || vm.act3Swiper3.realIndex == 0){
              vm.galleryIndex = vm.act3Swiper3.realIndex+1
            }
          },
        }
      })
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;  
      this.swiperSlideHeight =( w * (352.5/375) * (440.63/352.5)  * (206.53 / 440.63) ) + 'px';
    },

    /** 城市漫步 over */
    displayGallery(id){
      this.galleryData = [];
      this.isGalleryShow = true 
        switch(id){
          case 1:
            this.galleryTitle = '荷塘美景';
            break;
          case 2:
            this.galleryTitle = '精彩表演';
            break;
          case 3:
            this.galleryTitle = '“风情柳州 桂人游柳”旅游推介会';
            break;
        }

      let vm = this;      
      try{
        this.act3Swiper3.destroy(false);
      } catch(e){

      }
      setTimeout(() => {
        switch(id){
          case 1:
            vm.galleryData = vm.gallery1Data;
            break;
          case 2:
            vm.galleryData = vm.gallery2Data;
            break;
          case 3:
            vm.galleryData = vm.gallery3Data;
            break;
        }
        vm.galleryTotal = vm.galleryData.length
        vm.galleryIndex = 1
        setTimeout(() => {
          if(id == 3){
            vm.initLrljSwiper();
          } else{
            vm.initSwiper();
          }
        }, 200);
      }, 300);
      
    },
    closeGallery(){
      this.isGalleryShow = false
    },
      acT3Banner3Next(){ 
        
        try{
          this.act3Swiper3[1].slideNext();
        }catch(e){
           try{
          this.act3Swiper3[0].slideNext();
          
          
        }catch(e){
          this.act3Swiper3.slideNext();
        }
        }
        
      },
      acT3Banner3Prev(){ 
        
        
        try{
          this.act3Swiper3[1].slidePrev();
        }catch(e){
           try{
          this.act3Swiper3[0].slidePrev();
          
          
        }catch(e){
          this.act3Swiper3.slidePrev();
        }
        }
        
      },
    displayVideo(){
      let vm = this   
      this.isVideoShow = true
    },
    closeVideo(){      
      this.isVideoShow = false
    },
    displaySsj(){
      this.isSsjShow = true
    },
    closeSsj(){
      this.isSsjShow = false
    },
    displayYyj(){
      this.isFlqkShow = true
    },
    closeYyj(){
      this.isFlqkShow = false
    },
    displayYyjItem(id){
      this.yyjItemId = id
      this.isFlqkItemShow = true
    },
    closeYyjItem(){
      this.isFlqkItemShow = false
    },     
    displayPhoto(url) {
      ImagePreview({
        images: [ url ],
        showIndex:false,
        });
      },     
    goSingleNews(id){
      let url = '/act8/main/news?id='+id;
      this.$router.push(url)
    },
    goNews(type) {    
      let url = '';
      if(type == 1){
        //桂林
       url = '/act8/main/news?id=69040';
      } else  if(type == 2){
        //南宁;
       url = '/act8/main/news?id=69307';
      }else  if(type == 3){
        //潮州看柳州;
       url = '/act8/main/news?id=70685';//70654
      }else  if(type == 4){
        //卡乐星球;
       url = '/act8/main/news?id=70473';//70453
      }else  if(type == 5){
        //吃货柳州;
       url = '/act8/main/news?id=68783';
      }else  if(type == 6){
        //深圳看柳州;
       url = '/act8/main/news?id=70718';//70691
      }else  if(type == 7){
        //广州看柳州;
       url = '/act8/main/news?id=70825';//70821
      } else  if(type == 1001){
        //月月游柳-7月
        url = '/act8/main/newslist?type=1&cid=200&idArray=69441,69694';
      
      }else  if(type == 1002){
        //月月游柳-8月
        url = '/act8/main/newslist?type=2&cid=200&idArray=70473,70472';
      }else  if(type == 1003){
        //月月游柳-9月
       //url = '/act8/main/news?id=71406';
        url = '/act8/main/newslist?type=3&cid=200&idArray=71406,72280';
      }else  if(type == 1004){
        //月月游柳-9月 
        url = '/act8/main/newslist?type=3&cid=200&idArray=72409,72948';
      }else  if(type == 20191014){
        //尧告·去野;
       url = '/act8/main/news?id=72300';
      }
      this.$router.push(url)
 
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}

/* 福利全开 */

.btn-main-flqk {
  position: absolute;
  width: 23%;
  left: 37%;
  top: 32%;
}
.flqk-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold;
  margin-top: 18px;
}
.flqk-contents-item-address{
  font-size: 0.3rem;
  font-weight: bold;
  margin-top: 18px;
}
.act-8-main-flqk-p1{
  position: absolute;
  top: 29%;
  left: 0;
  width: 47%;
  height: 27%; 
}
.act-8-main-flqk-p2{
  position: absolute;
  top: 29%;
  right: 0;
  width: 47%;
  height: 27%; 
}
.act-8-main-flqk-p3{
  position: absolute;
  top: 59%;
  left: 0;
  width: 47%;
  height: 27%; 
} 
.act-8-main-flqk-p4{
  position: absolute;
  top: 59%;
  right: 0;
  width: 47%;
  height: 27%; 
}

/* 福利全开 over */



/* 精品线路 */

.btn-main-jpxl {
  position: absolute;
  width: 23%;
  top: 74%;
  left: 15%;
}
.act-8-main-jpxl-p1{
  position: absolute;
  top: 46%;
  left: 0;
  width: 34%;
  height: 40%; 
}
.act-8-main-jpxl-p2{
  position: absolute;
  top: 46%;
  left: 35%;
  width: 30%;
  height: 40%; 
}
.act-8-main-jpxl-p3{
  position: absolute;
  top: 46%;
  right: 0;
  width: 34%;
  height: 40%; 
}  

.jpxl-contents{
    position: absolute;
    top: 15%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #FFFFFF;
    font-size: 12px;
}

.jpxl-contents img{
  width: 100%;
}

.jpxl-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold; 
} 

.jpxl-contents p{
  text-indent: 24px;
}
.flqk-item-title{
  font-weight: bold;
}
/* 精品线路 over */



/* 月月游柳 */

.btn-main-yyyl {
  position: absolute;
  width: 23%;
  left: 60%;
  top: 55%;
}
.act-8-main-jpxl-p1{
  position: absolute;
  top: 46%;
  left: 0;
  width: 34%;
  height: 40%; 
}
.act-8-main-jpxl-p2{
  position: absolute;
  top: 46%;
  left: 35%;
  width: 30%;
  height: 40%; 
}
.act-8-main-jpxl-p3{
  position: absolute;
  top: 46%;
  right: 0;
  width: 34%;
  height: 40%; 
}  

.jpxl-contents{
    position: absolute;
    top: 15%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #FFFFFF;
    font-size: 12px;
}

.jpxl-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold; 
} 

.jpxl-contents p{
  text-indent: 24px;
}
.flqk-item-title{
  font-weight: bold;
}
/* 月月游柳 over */




/* 柳人力荐 */

.btn-main-lrlj {
  position: absolute;
  width: 23%;
  height: 30% !important;
  left: 51%;
  top: 72%;  
}
.act-8-main-jpxl-p1{
  position: absolute;
  top: 46%;
  left: 0;
  width: 34%;
  height: 40%; 
}
.act-8-main-jpxl-p2{
  position: absolute;
  top: 46%;
  left: 35%;
  width: 30%;
  height: 40%; 
}
.act-8-main-jpxl-p3{
  position: absolute;
  top: 46%;
  right: 0;
  width: 34%;
  height: 40%; 
}  

.jpxl-contents{
    position: absolute;
    top: 15%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #FFFFFF;
    font-size: 12px;
}

.jpxl-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold; 
} 

.jpxl-contents p{
  text-indent: 24px;
}
.flqk-item-title{
  font-weight: bold;
}
/* 柳人力荐 over */

 


/* 城市漫步 */

.btn-main-csmb {
  position: absolute;
  width: 23%;
  top: 30%;
  left: 78%;
}
.act-8-main-jpxl-p1{
  position: absolute;
  top: 46%;
  left: 0;
  width: 34%;
  height: 40%; 
}
.act-8-main-jpxl-p2{
  position: absolute;
  top: 46%;
  left: 35%;
  width: 30%;
  height: 40%; 
}
.act-8-main-jpxl-p3{
  position: absolute;
  top: 46%;
  right: 0;
  width: 34%;
  height: 40%; 
}  

.jpxl-contents{
    position: absolute;
    top: 15%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #FFFFFF;
    font-size: 12px;
}

.jpxl-contents-item-title{
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold; 
} 

.jpxl-contents p{
  text-indent: 24px;
}
.flqk-item-title{
  font-weight: bold;
}
/* 城市漫步 over */


/* 按钮 end */ 

.act-8-animation-banner-btn-mtj { 
  -webkit-animation: act-8-fadeIn 0.8s ease-in-out both; 
  animation: act-8-fadeIn 0.8s ease-in-out both;
  animation-delay: 700ms;
  -webkit-animation-delay: 700ms;
}
.act-8-main-btn-mtj {
  position: absolute;
  width: 10%;
  left: 60%;
  top: -28%;
}
.act-8-main-btn-layer {
  height:13%;  
  z-index: 3;
  /*background-color: rgba(42, 82, 117, 0.7)*/
}
.act-8-animation-banner-btn-spj { 
  -webkit-animation: act-8-fadeIn 0.8s ease-in-out both; 
  animation: act-8-fadeIn 0.8s ease-in-out both;
  animation-delay: 800ms;
  -webkit-animation-delay: 800ms;
}
.act-8-main-btn-spj {
  position: absolute;
  width: 10%;
  left: 75%;
  top: 10%;
}
.act-8-animation-banner-btn-ssj { 
  -webkit-animation: act-8-fadeIn 0.8s ease-in-out both; 
  animation: act-8-fadeIn 0.8s ease-in-out both;
  animation-delay: 900ms;
  -webkit-animation-delay: 900ms;
}
.act-8-main-btn-ssj {
  position: absolute;
  width: 10%;
  left: 63%;
  top: 53%;
}
.act-8-animation-banner-btn-yyj { 
  -webkit-animation: act-8-fadeIn 0.8s ease-in-out both; 
  animation: act-8-fadeIn 0.8s ease-in-out both;
  animation-delay: 1000ms;
  -webkit-animation-delay: 1000ms;
}
/* 按钮 */ 


/* 美图卷 */
.act-8-main-widnow-mtj,.act-8-main-gallery{
   position:fixed;
   left:50%;
   top:40%;
   width:94%;
   transform:translate(-50%,-40%);
   z-index:1000; 
}
.act-8-main-widnow-mtj-bg{
  position: relative;
  width: 100%;
} 
.page-act8-main .july{
  position: absolute;
  left:0;
  top:13%;
  width: 35%;
  height: 36%;
}
.act-8-main-widnow1-btn-close{
  position: absolute;
    right: -2%;
    top: 4.5%;
  width: 5%;
  padding: 7%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.act-8-main-widnow1-p1,.act-8-main-widnow1-p2,.act-8-main-widnow1-p3 {  
    position: absolute;
    top: 17%;
    width: 28%;
    height: 56%;
}
.act-8-main-widnow1-p1{
    left: 4%;
}
.act-8-main-widnow1-p2{
    left: 36%;
}
.act-8-main-widnow1-p3{
    left: 67%;
}

/* 美图卷 end */


/* 图集 */
.act-8-main-gallery-title{
    position: absolute;
    top: 15.5%;
    left: 0;
    width: 98%;
    font-size: 0.3rem;
    text-align: center;
    color: #FFFFFF;
}









.act-3-desc-content::-webkit-scrollbar {
  width: 7px;
  /*滚动条宽度*/
  height: 7px;
  /*滚动条高度*/
}


 
.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
  background-size: 38%;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
  background-size: 38%;
} 
 
.act-8-main-gallery-swiper-wrap{
  position: absolute;
  top: 28%;
  left: 0;  
  width: 100%; 
}


    .swiper-slide {
      text-align: center;
      font-size: 18px;
    /*  background: #fff;*/

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      display: block;
    }
	.swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
	}


.swiper-slide img{
  width: 100%;
  max-width: 180px;
  opacity: 1;
  border-radius: 20px;
}
.swiper-button-next,.swiper-button-prev{
  background-color:rgba(42, 82, 117, 0.7);   
  top:49%;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.swiper-button-prev{
  left: 9.2%;
}
.swiper-button-next{
  right: 9%;
} 
.swiper-page-info{
  position: absolute;
  top: 74%;
  left: 0;
  width: 98%;
  font-size: 0.25rem;
  text-align: center;
  color: #4e4e4e;
  font-weight: 300;
}
/* 图集 end */

/* 视频卷 */
.video{
  position: absolute;
  top: 25%;
  left: 5%;
  width: 90%;
}
/* 视频卷 end */

/* 身世卷 */
.flqk-contents{
    position: absolute;
    top: 15%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #FFFFFF;
    font-size: 12px;
}
.flqk-contents img{
  margin-top: 20px;
  width:100%;
}

/* 身世卷 end */


/* 友谊卷 */
.yyj-contents{
    position: absolute;
    top: 12%;
    left: 4%;
    width: 90%;
    height: 64%;
    overflow-y: scroll;
    color: #4f4f4f;
    font-size: 12px;
}
.yyj-contents img{
  width:100%;
  object-fit: cover;
}
.yyj-contents li{
  margin: 0;
  padding: 1%;
  width:29.9%;
  display:inline-table;
  margin-bottom: 10px;
}

.yyj-item-title{
  text-align: center;
  margin-top: 5px;
}
/* 友谊卷 end */ 

</style>
<style >
 



/* ACT-8 游泳，桂人 */ 

@-webkit-keyframes act-8-frames-bounce {
  0%, 50%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}
@keyframes act-8-frames-bounce {
  0%, 50%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -moz-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -moz-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}

 

@-webkit-keyframes act-8-frames-swim-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: translateX(5rem) rotateY(0deg); 
    transform: translateX(5rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(5rem) rotateY( -180deg); 
    transform: translateX(5rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  }
   
 
    
}
@keyframes act-8-frames-swim-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: translateX(5rem) rotateY(0deg); 
    transform: translateX(5rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(5rem) rotateY( -180deg); 
    transform: translateX(5rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  }
   
 
    
}

@-webkit-keyframes act-8-frames-swim-guiren-title-x
{
	0% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }
  100% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }  
}

@keyframes act-8-frames-swim-guiren-title-x
{
	0% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }
  100% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }  
}

@-webkit-keyframes page-act8-main-frames-swim-y
{
	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-1.5rem) ; transform: translateY(-1.5rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  }
 
    
}
@keyframes page-act8-main-frames-swim-y
{
	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-1.5rem) ; transform: translateY(-1.5rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  }
 
    
}


.act-8-animation-bounce { 
  -webkit-animation: act-8-frames-bounce 2s ease-out infinite; 
  animation: act-8-frames-bounce 2s ease-out infinite;
}
 
.page-act8-main .act-8-animation-guiren-swim-x{
  display: block;
  -webkit-animation: act-8-frames-swim-x 20s ease-out infinite; 
  animation: act-8-frames-swim-x 20s ease-out infinite;   
}
.page-act8-main .act-8-animation-guiren-swim-guiren-title-x{    
  display: inline-block;
  -webkit-animation: act-8-frames-swim-guiren-title-x 20s ease-out infinite; 
  animation: act-8-frames-swim-guiren-title-x 20s ease-out infinite;   
}
.page-act8-main .act-8-animation-guiren-swim-y{
  display: block;
  -webkit-animation: page-act8-main-frames-swim-y 20s ease-out infinite; 
  animation: page-act8-main-frames-swim-y 20s ease-out infinite;   
}


.act-8-banner-guiren-wrap {
  position: absolute;
  width: 20%;
  left: 0%;
  top: 55%;  
}

.act-8-banner-guiren { 
  width: 100%;
}
.act-8-main-guiren-title{ 
  position: absolute;
  top: -48%;
  left: 0;
  width: 60%;
}
/* ACT-8 游泳,桂人 over */ 


/* ACT-8 游泳，柳人 begin */ 
    
@-webkit-keyframes act-8-frames-swim-liuren-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-9rem) rotateY(0deg); 
    transform: translateX(-9rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-9rem) rotateY( -180deg); 
    transform: translateX(-9rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
}  
@keyframes act-8-frames-swim-liuren-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-9rem) rotateY(0deg); 
    transform: translateX(-9rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-9rem) rotateY( -180deg); 
    transform: translateX(-9rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
    @-webkit-keyframes act-8-frames-swim-liuren-title-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(0) rotateY( 180deg); 
    transform: translateX(0) rotateY( 180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( 180deg); 
    transform: translateX(0) rotateY( 180deg);
  } 
}  
@keyframes act-8-frames-swim-liuren-title-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(0) rotateY( 180deg); 
    transform: translateX(0) rotateY( 180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( 180deg); 
    transform: translateX(0) rotateY( 180deg);
  } 
    
}

    @-webkit-keyframes page-act8-main-frames-swim-liuren-y
{
	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-2rem) ; transform: translateY(-2rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  }
 
    
}
@keyframes page-act8-main-frames-swim-liuren-y
{
	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-2rem) ; transform: translateY(-2rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  }
 
    
}
.act-8-animation-swim-liuren-x{
  display: block;
  -webkit-animation: act-8-frames-swim-liuren-x 25s ease-out infinite; 
  animation: act-8-frames-swim-liuren-x 25s ease-out infinite;   
} 
.page-act8-main  .act-8-animation-swim-liuren-title-x{ 
  display: inline-block;
  -webkit-animation: act-8-frames-swim-liuren-title-x 25s ease-out infinite; 
  animation: act-8-frames-swim-liuren-title-x 25s ease-out infinite;   
} 
.act-8-animation-swim-liuren-y{
  display: block;
  -webkit-animation: page-act8-main-frames-swim-liuren-y 25s ease-out infinite; 
  animation: page-act8-main-frames-swim-liuren-y 25s ease-out infinite;   
}


.page-act8-main  .act-8-main-liuren-wrap {
  position: absolute;
  width: 22%;
  right: -20%;
  top: 100%;
}

.act-8-banner-liuren { 
  width: 100%;
}
.act-8-banner-liuren-title{
  position: absolute;
  top: -48%;
  left: 0;
  width: 60%;
}
/* ACT-8 游泳,桂人 over */ 





/* ACT-8 云 begin */ 

  @-webkit-keyframes act-8-frames-cloud-1
{
	
	
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-15rem) rotateY(0deg); 
    transform: translateX(-15rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-15rem) rotateY( -180deg); 
    transform: translateX(-15rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
  
@keyframes act-8-frames-cloud-1
{

	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-15rem) rotateY(0deg); 
    transform: translateX(-15rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-15rem) rotateY( -180deg); 
    transform: translateX(-15rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
}

@-webkit-keyframes act-8-frames-cloud-2
{

	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-8rem) rotateY(0deg); 
    transform: translateX(-8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-8rem) rotateY( -180deg); 
    transform: translateX(-8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
    
}

@keyframes act-8-frames-cloud-2
{
	
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-8rem) rotateY(0deg); 
    transform: translateX(-8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-8rem) rotateY( -180deg); 
    transform: translateX(-8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}


@-webkit-keyframes act-8-frames-cloud-3 {  
0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(8rem) rotateY(0deg); 
    transform: translateX(8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(8rem) rotateY( -180deg); 
    transform: translateX(8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
@keyframes act-8-frames-cloud-3
{
0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(8rem) rotateY(0deg); 
    transform: translateX(8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(8rem) rotateY( -180deg); 
    transform: translateX(8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}



.act-8-animation-cloud-1{
  -webkit-animation: act-8-frames-cloud-1 100s ease-out infinite; 
  animation: act-8-frames-cloud-1 100s ease-out infinite; 
}  
 
.act-8-main-cloud-1 {   
  position: fixed;
  width: 80%;
  right: -88%;
  top: -3%;
  z-index: 2;
}



.act-8-animation-cloud-2{
  -webkit-animation: act-8-frames-cloud-2 200s ease-out infinite; 
  animation: act-8-frames-cloud-2 200s ease-out infinite; 
}  
 
.act-8-main-cloud-2 {   
  position: fixed;
  width: 30%;
  right: -8%;
  top: 5%;
  z-index: 2;
}



.act-8-animation-cloud-3{
  -webkit-animation: act-8-frames-cloud-3 280s ease-out infinite; 
  animation: act-8-frames-cloud-3 280s ease-out infinite; 
}  
 
.act-8-main-cloud-3 {     
  position: fixed;
  width: 50%;
  left: -8%;
  top: 5%;
  z-index: 2;
}


/* ACT-8 云 over */ 

 
</style>
<style>
.page-act8-main{
}
/* tower */ 
.page-act8-main .tower-wrap{
  position:relative;
}
.page-act8-main .tower{
  width:100%;
}
.page-act8-main .mount{
  position:fixed;
  bottom:50px;
  left:0;
  width:100%;
}
  /* tower over */



.act-8-csmb-gallery .swiper-slide img{
  width: 86%;
  height: 100%;
  margin: auto;
  max-width: none;
}
.act-8-csmb-gallery .act-8-main-gallery-swiper-wrap{
  top:18%;
}
.act-8-csmb-gallery .swiper-button-next{
  top: 36%;
  right: 1%;    
  width: 5.4%;
  height: 100px;
  background-size: 60%;    
  background-color:#FFFFFF;
  border-radius: 0;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23418aa4'%2F%3E%3C%2Fsvg%3E") !important;
}
.act-8-csmb-gallery .swiper-button-prev{
  top: 36%;
  left:1px;
  width: 5.4%;
  height: 100px;
  background-size: 60%;    
  background-color:#FFFFFF;
  border-radius: 0;  
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23418aa4'%2F%3E%3C%2Fsvg%3E") !important;
}
</style>


// WEBPACK FOOTER //
// src/components/act/8/Main.vue